<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
          <h2> StingyCat's Out-of-Control Tipping Antidote </h2>
          <p>
            Purr-hello, fellow fiscally responsible felines! Have you noticed how tipping has turned into a wild catnip party? Let's take a humorous yet practical pause at the tip-tipping scale. Originally, tipping was like a mouse treat for service staff, a way to make up for their meager cheese (wages). But now, it's like everyone's expecting a whole wheel of cheese, even for the tiniest squeak of service!  
          </p>
          <p>
            Here in the great land of Canada, where we bid adieu to pennies, we still hold dear the saying, "A penny saved is a penny earned." So why tip like we're rolling in catnip when a simple purr will do? Especially when you're the one doing all the tail-twitching work in takeouts – driving, waiting, and sometimes even engaging in that confusing dance of human interaction!
          </p>
          <p>
            Let's dial back the tipping madness, shall we? Use our savvy calculator to tip smartly based on the pre-tax amount. Remember, tipping is a sign of gratitude for good service, not an automatic reflex every time someone meows at you. And it's utterly purr-fect to not tip for takeout or when getting coffee – your wallet, your rules! 
          </p>
          <p>
            Now, let’s calculate that tip – not every server's service is worth a lion's share, after all!
          </p>
  
          <!-- Province Selector for Tax Calculation -->
          <label for="province">Select Your Province:</label>
          <select id="province" v-model="selectedProvince">
            <option value="AB">Alberta</option>
            <option value="BC">British Columbia</option>
            <option value="MB">Manitoba</option>
            <option value="NB">New Brunswick</option>
            <option value="NL">Newfoundland and Labrador</option>
            <option value="NS">Nova Scotia</option>
            <option value="NT">Northwest Territories</option>
            <option value="NU">Nunavut</option>
            <option value="ON">Ontario</option>
            <option value="PE">Prince Edward Island</option>
            <option value="QC">Quebec</option>
            <option value="SK">Saskatchewan</option>
            <option value="YT">Yukon</option>
          </select>
  
          <!-- Total Bill Amount Input -->
          <label for="totalBillAmount">Total Bill Amount (With Tax):</label>
          <input type="number" id="totalBillAmount" v-model.number="totalBillAmount" placeholder="Enter total amount" step="0.01">
  
          <!-- Pre-Tax Bill Amount Display -->
          <div v-if="preTaxAmount !== null">
            <h3>Pre-Tax Bill Amount: ${{ preTaxAmount.toFixed(2) }}</h3>
          </div>
  
          <!-- Tip Calculation Section -->
          <label for="tipPercentage">Tip Percentage:</label>
          <select id="tipPercentage" v-model.number="tipPercentage">
            <option value="10">10%</option>
            <option value="15">15%</option>
            <option value="20">20%</option>
            <option value="custom">Custom</option>
          </select>
  
          <div v-if="tipPercentage === 'custom'">
            <label for="customTip">Custom Tip Percentage:</label>
            <input type="number" id="customTip" v-model.number="customTip" placeholder="Enter custom tip" step="0.01">
          </div>
  
          <button @click="calculateTip">Calculate Tip</button>
  
          <!-- Calculated Tip and Savings Display -->
          <div v-if="calculatedTip !== null">
            <h3>Suggested Tip: ${{ calculatedTip.toFixed(2) }}</h3>
            <p>You save ${{ savings.toFixed(2) }} by tipping on the pre-tax amount!</p>
          </div>
        </div>
      </div>

      
    </div><br><br><br><br><br><br>
  </template>
  
  <script>
  export default {
    data() {
      return {
        selectedProvince: 'AB',
        totalBillAmount: 0,
        preTaxAmount: null,
        tipPercentage: 15,
        customTip: 0,
        calculatedTip: null,
        savings: null,
        taxRates: {
          'AB': 5, // Alberta
          'BC': 12, // British Columbia
          // Add other provinces and their tax rates here
          'MB': 8, // Manitoba
          'NB': 15, // New Brunswick
          'NL': 15, // Newfoundland and Labrador
          'NS': 15, // Nova Scotia
          'NT': 5, // Northwest Territories
          'NU': 5, // Nunavut
          'ON': 13, // Ontario
          'PE': 15, // Prince Edward Island
          'QC': 14.975, // Quebec
          'SK': 6, // Saskatchewan
          'YT': 5 // Yukon
        },
      };
    },
    methods: {
      calculatePreTaxAmount() {
        let taxRate = this.taxRates[this.selectedProvince];
        this.preTaxAmount = this.totalBillAmount / (1 + taxRate / 100);
      },
      calculateTip() {
        this.calculatePreTaxAmount();
        let tipPercent = this.tipPercentage === 'custom' ? this.customTip : this.tipPercentage;
        this.calculatedTip = (this.preTaxAmount * tipPercent) / 100;
        this.calculateSavings(tipPercent);
      },
      calculateSavings(tipPercent) {
        let postTaxTip = (this.totalBillAmount * tipPercent) / 100;
        this.savings = postTaxTip - this.calculatedTip;
      }
    }
  }
  </script>
  

   <style scoped>
  .wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  }
  .video-container {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
      padding-top: 25px;
      height: 0;
    }
  
    .video-container iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  .content-container {
  background-color: #4A148C ;  /* Light orange color */
  color: black;
  padding: 20px;
  border-radius: 20px;  /* Adjust this value to your preference */
  overflow: hidden; 
  }
  .stingy-card {
  flex: 1;  /* Take up equal width as the iframe */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white
  }
  
  .stylish-links {
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  
  .stylish-links h3 {
  color: #333;
  font-size: 1.4em;
  margin-bottom: 15px;
  }
  
  .stylish-links ul {
  list-style: none;
  padding: 0;
  }
  
  .stylish-links ul li {
  background-color: #fff;
  margin: 10px 0;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  }
  
  .stylish-links ul li a {
  color: black;
  text-decoration: none;
  font-weight: bold;
  }
  
  .stylish-links ul li:hover {
  background-color: #4A148C;
  }
  
  .stylish-links ul li:hover a {
  color: #fff;
  }

  button {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}

button:hover {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
}
  </style>